const select = {
  select:'Выбрать',
  placeholder:'Выбрать предмет',
  sort_by: 'Сортировать по',
  favorite: 'Любимое',
  title: 'Название',
  developer: 'Разработчик',
  mostPromoted: 'Самый продвигаемый',
  ipAddress: 'IP-адрес',
  appPackage: 'Пакет программы',
  selectAppId: 'Идентификатор приложения',
  developerName: 'Имя разработчика',
  paypalEmail: 'Электронный адрес Paypal',
  paypalEmailFraud: 'Электронный адрес Paypal (мошенничество)',
  emailService: 'Служба электронной почты',
  developerEmail: 'Электронный адрес разработчика',
  cpiAppPackage: 'Пакет программы Cpi',
  userEmail: 'Электронный адрес пользователя',
  keyword: 'Ключевое слово',
};
export default select;
